<script lang="ts" setup>
import { getData } from './logic'

const data = getData()
const router = useRouter()
const { cta, reply } = data.settings
const isReplyEnabled = reply.enabled && !data.audio.isReply

function handleCTAClick() {
  const { name, inviteCode } = data.user

  if (cta.link)
    return window.open(cta.link, '_blank')

  router.push({
    path: `/join/${inviteCode}`,
    state: { name }
  })
}

function onReplyClick() {
  track('Click: listen page reply button')
}
</script>

<template>
  <div
    class="flex lt-xxs:flex-col gap-4 items-center justify-end opacity-0 animate-name-fade animate-forwards animate-ease-out animate-delay-250 animate-duration-250"
  >
    <span class="text-label-3 text-$color-neutral opacity-35">{{ cta.message }}</span>

    <div class="flex-center gap-3">
      <CTAButton v-if="cta.enabled" :variant="isReplyEnabled ? 'secondary' : 'primary'" class="cta" @click="handleCTAClick">
        {{ cta.button }}
      </CTAButton>

      <PageListenReply v-if="isReplyEnabled" :accound-id="data.user.inviteCode" :audio-id="data.audio.id">
        <CTAButton variant="primary" class="cta" @click="onReplyClick">
          {{ reply.label }}
        </CTAButton>
      </PageListenReply>
    </div>
  </div>
</template>

<style scoped lang="css">
.cta {
  @apply !h-10 lt-sm:h-8;
}
</style>
